const plpCarousel = document.querySelectorAll(".js-pdp-card-carousel");
if (plpCarousel.length) {
  plpCarousel.forEach(function (el, index) {
    el.classList.add(`s${index}`);
    new Swiper(`.js-pdp-card-carousel.s${index}`, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      initialSlide: 0,
      loop: false,
      freeMode: true,
      a11y: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        0:{
            spaceBetween: 24
        },
        769: {
            spaceBetween: 24
        },
        1024: {
            spaceBetween: 16
        },
        1201: {
            spaceBetween: 16
        },
        1440: {
            spaceBetween: 16
        }
      }
    });
  });
}
